export default class ArticoliListing {
    constructor(node) {
        this.node = node;
        this.filtriNode = node.querySelector('.section--filtri');
        this.listingNode = node.querySelector('.section--listing--news');
        this.loadMoreNode = node.querySelector('[data-load-more]');

        this.pageNumber = 1;
        this.pageSize = this.loadMoreNode.dataset.pageSize;
        
        this.selectedFilters = {
            categoria: [],
            data: []
        };

        this.addListeners();
    }

    static init() {
        let ArticoliListingNode = document.querySelector("[data-articoli-listing]");

        if (ArticoliListingNode) {
            return new ArticoliListing(ArticoliListingNode);
        }
    }

    addListeners() {
        let _this = this;

        this.filtriNode.querySelector('.filtri-scelti').addEventListener('click', function(event) {
            if (event.target.dataset.filter === undefined) {
                return;
            }

            _this.toggleFilter(event.target);
            _this.updateFilters(event.target);
            
            _this.pageNumber = 1;
            
            _this.updateListing();
        });
        
        this.loadMoreNode.addEventListener('click', function(event) {
            event.preventDefault();
            
            _this.pageNumber++;
            
            _this.updateListing(false);
        });
    }
    
    appendFilters(filters, filtersType, filtersWrapper) {
        filtersWrapper.innerHTML = '';

        for (let id in filters) {
            let filtroOption = filters[id];

            let filtroNode = document.createElement('a');
            filtroNode.setAttribute('data-filter-type', filtersType);
            filtroNode.setAttribute('data-filter', id);
            filtroNode.setAttribute('href', '#');
            filtroNode.innerHTML = filtroOption;

            let wrapperNode = document.createElement('li');
            wrapperNode.appendChild(filtroNode);

            filtersWrapper.appendChild(wrapperNode);
        }
    }
    
    updateFilters(selectedFilterNode) {
        let _this = this;
        
        let responseData = {};
        
        let submittedData = {
            categorieSelezionate: [],
            dateSelezionate: []
        };

        let selectedFilterType = selectedFilterNode.dataset.filterType;

        if (selectedFilterType === "categoria") {
            submittedData.categorieSelezionate = this.selectedFilters.categoria;
        }
        else {
            submittedData.dateSelezionate = this.selectedFilters.data;
        }
        
        this.filtriNode.classList.add('busy');
        
        $.ajax({
            type: "POST",
            url: "/WS/wsArticoliNews.asmx/GetFiltri",
            cache: false,
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(submittedData),
            dataType: "json",
            success: function (data) {
                responseData = JSON.parse(data.d.HTML);
                
                if (selectedFilterType === "categoria" || selectedFilterType === undefined) {
                    let filtersOptions = responseData.Date;
                    let filtersType = 'data';
                    let filtersWrapper = _this.filtriNode.querySelector('.filtro-data');
                    
                    _this.appendFilters(filtersOptions, filtersType, filtersWrapper);
                }
                
                if (selectedFilterType === "data" || selectedFilterType === undefined) {
                    let filtersOptions = responseData.Categorie;
                    let filtersType = 'categoria';
                    let filtersWrapper = _this.filtriNode.querySelector('.filtro-categoria');

                    _this.appendFilters(filtersOptions, filtersType, filtersWrapper);
                }
            },
            error: function (data) {
                responseData = data;
            },
            complete: function() {
                _this.filtriNode.classList.remove('busy');
            }
        });        
    }

    updateListing(clearListing) {
        let _this = this;
        let responseData = {};

        let submittedData = {
            categorieSelezionate: this.selectedFilters.categoria,
            dateSelezionate: this.selectedFilters.data,
            pageSize: this.pageSize,
            pageNumber: this.pageNumber
        };
        
        if (clearListing === undefined) {
            clearListing = true;
        }

        this.loadMoreNode.classList.add('busy');
        
        $.ajax({
            type: "POST",
            url: "/WS/wsArticoliNews.asmx/GetListingArticoli",
            cache: false,
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(submittedData),
            dataType: "json",
            success: function (data) {
                responseData = JSON.parse(data.d.HTML);

                let $grid = $('.crazy-grid');
                let $renderedOutput = $(responseData.renderedOutput);
                
                if (clearListing) {
                    _this.listingNode.querySelector('.crazy-grid .items').innerHTML = '';
                }

                $grid.masonry('layout');

                $('.items', $grid).append($renderedOutput).imagesLoaded(function(){
                    $grid.masonry('appended', $renderedOutput);
                });
                
                if (_this.pageNumber * _this.pageSize >= responseData.totalResults) {
                    _this.loadMoreNode.style.display = "none";
                }
                else {
                    _this.loadMoreNode.style.display = "block";
                }
            },
            error: function (data) {
                responseData = data;
            },
            complete: function() {
                _this.loadMoreNode.classList.remove('busy');
            }
        });
    }

    toggleFilter(filterNode) {
        let _this = this;
        let filterID = filterNode.dataset.filter;
        let filterType = filterNode.dataset.filterType;
        let addFilter = true;

        if (filterID === "all") {
            // "Rimuovi tutti i filtri"
            _this.selectedFilters = {
                categoria: [],
                data: []
            };

            return;
        }

        Object.keys(this.selectedFilters).forEach(function(key,i) {
            let index = _this.selectedFilters[key].indexOf(filterID);

            if (index > -1) {
                _this.selectedFilters[key].splice(index, 1);
                addFilter = false;
            }
        });

        if (addFilter){
            this.selectedFilters[filterType].push(filterID);
        }
    }
}